// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__50iRm","content":"ManualTimeModal_content__2jZ1Q"};